import { submitFormData } from '@scripts/modules/sendFormData.js';
import initValidation from '@scripts/utils/initValidation.js';

const formSelector = document.querySelector('.js-tickets-form');
const actionUrlForm = formSelector.getAttribute('action') || window.wp_data.ajax;

const titleEl = formSelector.closest('.l-ticket-form')?.querySelector('.c-title');
// const originalTitle = titleEl?.textContent || '';
const successMsg = formSelector.getAttribute('data-success-message') || '';
const errorMsg = formSelector.getAttribute('data-error-message') || '';

const setTitle = (text, cssState, compact = false) => {
  if (!titleEl) return;
  titleEl.textContent = text;
  titleEl.classList.remove('is-success', 'is-error', 'is-compact');
  if (cssState) titleEl.classList.add(cssState);
  if (compact) titleEl.classList.add('is-compact');
};

const formValidator = await initValidation({
  formSelector,
  validateFields: {
    name: '.js-tickets-form [name="name"]',
    email: '.js-tickets-form [name="email"]',
    date: '.js-tickets-form [name="date"]',
    number: '.js-tickets-form [name="travelers"]',
    select: '.js-tickets-form #destination',
    // eslint-disable-next-line no-dupe-keys
    select: '.js-tickets-form #inquiry',
    submit: '.js-tickets-form button[type="submit"]',
  },
});

submitFormData({
  fetchUrl: actionUrlForm,
  formElement: formSelector,
  formValidation: formValidator,
  onSuccess: () => {
    const needCompact = successMsg.length > 20;
    setTitle(successMsg, 'is-success', needCompact);
    formSelector.reset();
  },
  onError: () => {
    const needCompact = errorMsg.length > 20;
    setTitle(errorMsg, 'is-error', needCompact);
  },
});
